import { cn } from '@/lib/utils';
import { difficultyColors } from '@/utils/constants';

interface ColourBorderProps {
  difficulty: number;
  variant?: 'default' | 'horizontal';
  className?: string;
}

const ColourBorder = (props: ColourBorderProps) => {
  const { difficulty, variant = 'default', className } = props;
  const difficultyColor = difficultyColors[difficulty - 1];

  if (variant === 'horizontal') {
    return (
      <div
        className={cn(
          `h-2 w-full shrink-0 rounded print:hidden`,
          difficultyColor,
          className,
        )}
      />
    );
  }

  return (
    <div
      className={cn(`w-2 shrink-0 print:hidden`, difficultyColor, className)}
    />
  );
};

export default ColourBorder;
